const LOAN_KEYS = {
  all: ["loan"],
  status: (loanId) => [...LOAN_KEYS.all, "status", loanId]
};

export default { LOAN_KEYS };
